import { formatMyDate, checkDate } from "../filters/funcs";
import { upperFirst } from "@/lib/filters/funcs";

export const getNestedValue = (path, obj) => {
  return path.reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj);
};

export const getInitImmutableValues = (initValue, field, value) => {
  if (!initValue[field.name]) {
    if (field.type === "autocompleteInput" && field.resource) {
      // TO-DO Couldn't find a case to enter here so it's not tested, please check if needed
      const getValuePath = field.valuePath.concat([field.prop]);
      const showValue = field.valuePath.concat([field.searchParamName]);
      value[field.name] = getNestedValue(getValuePath, initValue);
      field.showValue = getNestedValue(showValue, initValue);
    } else {
      value[field.name] = getNestedValue(field.valuePath, initValue);
    }
  }
};

export const getDateInitValue = (fieldInitVal) => {
  if (
    fieldInitVal &&
    (fieldInitVal instanceof Date ||
      (typeof fieldInitVal === "string" && checkDate(fieldInitVal)))
  ) {
    return formatMyDate(fieldInitVal, true);
  }
  return null;
};

export const getMultiInitValues = ({ initValue, multiParams, isSortable }) => {
  const mapValue = [];
  const mapShowValue = [];
  const {
    propName,
    subPropName,
    label = "name",
    subLabel = "name",
    value = "@id"
  } = multiParams;

  const getLabel = (item) =>
    subPropName && item[subPropName]
      ? `${item[subPropName][subLabel]} - ${item[label]}`
      : item[label];

  if (initValue[propName]) {
    []
      .concat(initValue[propName])
      .sort((a, b) => {
        const labelA = getLabel(a);
        const labelB = getLabel(b);
        if (isSortable) return 0; // if multi is dnd sortable skip sorting here
        return labelA > labelB ? 1 : -1;
      })
      .map((multiItem) => {
        mapValue.push(multiItem[value]);

        const labelValue = getLabel(multiItem);

        mapShowValue.push({ label: labelValue, value: multiItem[value] });
        return true;
      });
  }
  return {
    mapValue,
    mapShowValue
  };
};

export const generateFormTitle = (apiParams, config, mode, item) => {
  if (config.customFormTitle) {
    return config.customFormTitle(mode, item);
  }

  const entityName = config?.formEntity || upperFirst(apiParams?.entity);
  return entityName ? `${upperFirst(mode) + " " + entityName}` : "";
};

export const filterNotSubmitFields = (values, fieldsToExclude) => {
  const filteredValues = { ...values };

  for (const fieldName of fieldsToExclude) {
    if (filteredValues.hasOwnProperty(fieldName)) {
      delete filteredValues[fieldName];
    }
  }

  return filteredValues;
};

export const formatViolationsAsErrors = (violations = []) => {
  return violations.reduce((acc, violation) => {
    const [key, nestedKey] = violation.propertyPath.split(".");
    acc[nestedKey || key] =
      violation.message.slice(-1) !== "."
        ? `${violation.message}.`
        : violation.message;
    return acc;
  }, {});
};
